module.exports = __webpack_public_path__ + "static/media/deleteGray.285014d1.svg";